import ListingEventiTemplate from '@components/templates/ListingEventiTemplate/ListingEventiTemplate'
import { initializeApollo } from '@gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { CONTESTS, PAGINA } from 'utils/queries'
import { ContestType, PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
  contests: [ContestType]
}

function EventoDetail({ pagina, contests }: Props) {
  return <ListingEventiTemplate contests={contests} pagina={pagina} />
}

export const getServerSideProps = NextWrapper.getServerSideProps(async ({ req }) => {
  const headers = req?.headers?.cookie ? { cookie: req.headers.cookie } : undefined
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'concorsi-e-promozioni' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  const {
    data: { contests },
  } = await client.query({
    query: CONTESTS,
    context: {
      headers,
    },
  })

  return {
    props: { pagina, contests },
  }
})

export default EventoDetail
